import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TuiTabs } from '@taiga-ui/kit';
import { UserListComponent } from './components/user-list/user-list';
import { RoleListComponent } from './components/role-list/role-list';

export type UsersRolesTab = 'users' | 'roles';

@Component({
  selector: 'app-settings-users-roles',
  templateUrl: 'users-roles.html',
  styleUrl: 'users-roles.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TuiTabs, UserListComponent, RoleListComponent],
})
export class UsersRolesComponent {
  readonly activeTab = input<UsersRolesTab>('users');

  readonly tabChange = output<UsersRolesTab>();
  readonly addUser = output<void>();
  readonly editUser = output<number>();
  readonly addRole = output<void>();
  readonly editRole = output<number>();
  readonly copyRole = output<number>();
}
